<script lang="ts">
    import type {IPagoDetalles} from "../../../interfaces";
    import {getFormatter} from "../../../utils";
    export let data: IPagoDetalles;
     const formatter = getFormatter();
</script>
<section class="my-15">
    <div class="grid-2 m:grid-1 m:gap-1">
        <div class="left-block">
           <h3 class="primary mb-ii" style="font-weight: 500">Información de la póliza</h3>
            <table class="simple-table">
                <tr>
                    <td style="min-width: 100px">Tomador</td>
                    <td>{data.poliza.tomador}</td>
                </tr>
                <tr>
                    <td>Producto</td>
                    <td>{data.poliza.producto}</td>
                </tr>
                <tr>
                    <td>No. Póliza</td>
                    <td>{data.poliza.numero}</td>
                </tr>
                <tr>
                    <td>Endoso</td>
                    <td>{data.poliza.endoso}</td>
                </tr>
                <tr>
                    <td>Riesgo</td>
                    <td>{data.poliza.riesgo}</td>
                </tr>
                <tr>
                    <td>Vigencia</td>
                    <td>{data.poliza.vigencia}</td>
                </tr>
            </table>
        </div>
        <div class="pl-2 m:pl-0">
            <h3 class="primary mb-ii" style="font-weight: 500">Detalles del pago</h3>
            <table class="simple-table">
                <tr>
                    <td>Valor pendiente</td>
                    <td style="font-weight: 600">{formatter(data.valorPendiente)}</td>
                </tr>
                <tr>
                    <td>Fecha límite de pago</td>
                    <td>{data.fechaLimite}</td>
                </tr>
                <tr>
                    <td>Forma de pago</td>
                    <td>{data.formaPago}</td>
                </tr>
                <tr>
                    <td>No. cuotas pendientes</td>
                    <td>{data.cuotasPendientes} cuotas</td>
                </tr>
            </table>
        </div>
    </div>
</section>
<style>
    section{
        padding-left:calc(50px + .5rem);
    }

    .left-block{
        border-right: 1px solid var(--border-color);
    }

    @media(max-width: 1024px){
        section{
            padding-left: 0;
        }

        .left-block{
            border-right:0;
            border-bottom:1px solid var(--border-color);
            padding-bottom:1rem;
        }

    }
</style>